<template>
  <tr>
    <td>
      <v-simple-checkbox :value="isSelected" @click="select(!isSelected)" :ripple="false" />
    </td>
    <td><CardStudentName :student="item.student" /></td>
    <td>{{ item.student.dob | ddmmyyyy }}</td>
    <td>
      <v-chip
        :color="item.status === 'present' ? 'green' : item.status === 'absent' ? 'orange' : 'gray'"
        :text-color="item.status === 'none' ? 'black' : 'white'"
      >
        {{ item.status | getStatus }}
      </v-chip>
    </td>
    <td>
      <div class="status-buttons d-flex flex-wrap align-center">
        <!-- Primary status -->
        <v-btn
          :outlined="status !== 'present'"
          class="mr-2 mb-2"
          color="success"
          small
          @click="changeStatus('present')"
        >
          Có mặt
        </v-btn>
        <v-btn :outlined="status !== 'absent'" class="mr-2 mb-2" color="warning" small @click="changeStatus('absent')">
          Vắng mặt
        </v-btn>

        <!-- Substatus: only meaningful when status is present -->
        <v-btn
          v-if="status === 'present'"
          :outlined="item.subStatus !== 'onTime'"
          class="mr-2 mb-2"
          color="success"
          small
          @click="updateItem('onTime')"
        >
          Đúng giờ
        </v-btn>
        <v-btn
          v-if="status === 'present'"
          :outlined="item.subStatus !== 'lateTime'"
          class="mr-2 mb-2"
          color="warning"
          small
          @click="updateItem('lateTime')"
        >
          Vào muộn
        </v-btn>

        <!-- Substatus: only meaningful when status is absent -->
        <v-btn
          v-if="status === 'absent'"
          :outlined="item.subStatus !== 'excused'"
          class="mr-2 mb-2"
          color="success"
          small
          @click="updateItem('excused')"
        >
          Có phép
        </v-btn>
        <v-btn
          v-if="status === 'absent'"
          :outlined="item.subStatus !== 'unexcused'"
          class="mr-2 mb-2"
          color="warning"
          small
          @click="updateItem('unexcused')"
        >
          Không phép
        </v-btn>
      </div>
    </td>
    <td></td>
  </tr>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions } from 'vuex'
import { getDataSubStatus, getStatusData } from './headers'
export default {
  components: { CardStudentName },
  props: { item: Object, expand: Function, isExpanded: Boolean, select: Function, isSelected: Boolean },
  data() {
    return { status: '' }
  },
  mounted() {
    this.status = this.item.status
  },
  methods: {
    ...mapActions({
      update: 'slotStudentAttendance/update'
    }),

    async changeStatus(status) {
      if (status === this.status) return
      this.status = status
      await this.update({ id: this.item._id, status: status })
      this.$emit('reset')
      this.$alert.success('Điểm danh thành công')
    },

    updateItem(subStatus) {
      if (subStatus === this.item.subStatus) return
      this.$dialog.confirm({
        title: 'Xác nhận điểm danh',
        text: this.getTextPopup(this.status, subStatus),
        okText: 'Xác nhận',
        cancelText: 'Huỷ',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: this.item._id, status: this.status, subStatus })
            this.item.subStatus = subStatus
            this.$emit('reset')
            this.$alert.success('Điểm danh thành công')
          } catch (e) {
            this.$alert.errors(e)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    getTextPopup(status, subStatus) {
      const textStatus = this.getStatusData('', status)
      const textSubStatus = this.getDataSubStatus('', subStatus)
      const colorStatus = this.getStatusData('color', status)
      const colorSubStatus = this.getDataSubStatus('color', subStatus)
      return `<div>Xác nhận điểm danh với trạng thái <span style="font-weight: bold; ${colorStatus}">${textStatus}</span> và <span style="font-weight: bold;${colorSubStatus}">${textSubStatus}</span> cho học sinh này.</div>`
    },
    getDataSubStatus: getDataSubStatus,
    getStatusData: getStatusData
  },
  filters: {
    getStatus(status) {
      switch (status) {
        case 'present':
          return 'Có mặt'
        case 'absent':
          return 'Vắng mặt'
        default:
          return 'Chưa điểm danh'
      }
    }
  },
  watch: {
    item: {
      handler(val) {
        this.status = val.status
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
.status-buttons > .v-btn {
  min-width: 90px;
}
</style>
